import { Card, Stack } from '@mui/material';

const ProfileWrapper = ({ children }) => {
    return (
        <Card sx={{ height: "100vh", borderRadius: "36px", mt: "25px", mx:"40px" }} elevation={0}>
            <Stack flexDirection={"column"} alignItems={"center"} justifyContent={"center"} gap={0}>
                {children}
            </Stack>
        </Card>
    );
};

export default ProfileWrapper;
